export function isValidRangeAndNotNull(start, end, seqLength) {
  if (!(start != null && end != null)) {
    return false;
  }
  return 0 <= start && start < end && end <= seqLength;
}

export function baseInRangeAndNotNull(pos, start, end) {
  if (pos == null) {
    return false;
  }
  return start <= pos && pos < end;
}
